import http from './http'
import qs from 'qs'

function getStorage (params) {
  return http({
    method: 'GET',
    url: '/storage/paginated',
    params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

function getStorageById (id) {
  return http({
    method: 'GET',
    url: '/storage/' + id
  })
}

function getSmartDirectory (id) {
  return http({
    method: 'GET',
    url: '/smartDirs/' + id
  })
}

function getStorageFileById (guid, callback) {
  return http({
    method: 'GET',
    url: '/files/' + guid + '/download',
    responseType: 'blob',
    timeout: Infinity,
    onDownloadProgress: ({ loaded, total, type }) => {
      const percent = (100 / total * loaded).toFixed()
      callback(percent)
    }
  })
}

function deleteStorageByArray (ids) {
  return http({
    method: 'DELETE',
    url: '/storage',
    data: ids,
    timeout: Infinity
  })
}

function deleteStorageById (id) {
  return http({
    method: 'DELETE',
    url: '/storage/' + id
  })
}

function deleteStorageResourceById (guid) {
  return http({
    method: 'DELETE',
    url: '/files/' + guid
  })
}

function deleteStorageResourceByArray (guids) {
  return http({
    method: 'DELETE',
    url: '/files',
    data: guids
  })
}

function deleteStorageAssignmentByArray (id, data) {
  return http({
    method: 'DELETE',
    url: '/storage/' + id + '/files',
    data
  })
}

function deleteStorageAssignmentById (id, guid) {
  return http({
    method: 'DELETE',
    url: '/storage/' + id + '/files' + guid
  })
}

function createStorageDirectory (params) {
  return http({
    method: 'POST',
    url: '/dirs',
    data: params
  })
}

function createStorageDirectoryById (id, params) {
  return http({
    method: 'POST',
    url: '/dirs?rootId=' + id,
    data: params
  })
}

function createSmartDirectory (params) {
  return http({
    method: 'POST',
    url: '/smartDirs',
    data: params
  })
}

function createSmartDirectoryById (id, params) {
  return http({
    method: 'POST',
    url: '/smartDirs?rootId=' + id,
    data: params
  })
}

function updateSmartDirectory (id, params) {
  return http({
    method: 'PUT',
    url: '/smartDirs/' + id,
    data: params
  })
}

function createStorageAssignmentByArray (id, data) {
  return http({
    method: 'POST',
    url: '/storage/' + id + '/files',
    data
  })
}

function createStorageAssignmentById (id, guid) {
  return http({
    method: 'POST',
    url: '/storage/' + id + '/files/' + guid
  })
}

function upload (file, callback) {
  const data = new window.FormData()
  data.append('file', file)

  return http({
    method: 'POST',
    url: '/files/upload',
    data,
    onUploadProgress: ({ total, loaded }) => {
      const percent = Number(Math.round(loaded / total * 100).toFixed(2))
      callback(percent)
    },
    timeout: Infinity
  })
}

function update (guid, data, file, onProgress) {
  return http({
    method: 'POST',
    url: '/files/' + guid + '/update',
    data,
    onUploadProgress: ({ total, loaded }) => {
      onProgress({ percent: Number(Math.round(loaded / total * 100).toFixed(2)) }, file)
    },
    timeout: Infinity
  })
}

function uploadStorageFileById (id, data) {
  return http({
    method: 'POST',
    url: '/files//upload',
    data: {
      data,
      rootId: id
    }
  })
}

function replaceStorageFileById (guid, params) {
  return http({
    method: 'POST',
    url: '/files/' + guid + '/update',
    data: qs.stringify(params)
  })
}

function updateProperties (guid, params) {
  return http({
    method: 'PUT',
    url: '/files/' + guid + '/properties',
    data: params
  })
}

function updateStorageFileById (id, params) {
  return http({
    method: 'PATCH',
    url: '/storage/' + id + '/info',
    data: params
  })
}

function addTag (guid, id) {
  return http({
    method: 'PUT',
    url: '/files/' + guid + '/tags/' + id
  })
}

function addTags (guid, array) {
  return http({
    method: 'POST',
    url: '/files/' + guid + '/tags',
    data: {
      ids: array
    }
  })
}

function removeTag (guid, id) {
  return http({
    method: 'DELETE',
    url: '/files/' + guid + '/tags/' + id
  })
}

function removeTags (guid, array) {
  return http({
    method: 'DELETE',
    url: '/files/' + guid + '/tags',
    data: {
      ids: array
    }
  })
}

function getThumbnail (guid) {
  return http({
    method: 'GET',
    url: '/files/' + guid + '/thumbnail/download',
    timeout: Infinity,
    responseType: 'blob'
  })
}

export {
  getStorage,
  getStorageById,
  getStorageFileById,
  deleteStorageById,
  deleteStorageByArray,
  deleteStorageResourceById,
  deleteStorageResourceByArray,
  deleteStorageAssignmentById,
  deleteStorageAssignmentByArray,
  createStorageDirectory,
  createStorageDirectoryById,
  createStorageAssignmentById,
  createStorageAssignmentByArray,
  upload,
  update,
  uploadStorageFileById,
  replaceStorageFileById,
  updateProperties,
  updateStorageFileById,
  addTag,
  addTags,
  removeTag,
  removeTags,

  createSmartDirectory,
  createSmartDirectoryById,

  getSmartDirectory,
  updateSmartDirectory,
  getThumbnail
}



// WEBPACK FOOTER //
// ./src/services/api/storage.js